import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";

export default function BreadCrumb({ link, title, breadcrumbItem }) {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between mt-3">
          {/* <h4 className="mb-0 font-size-18">{breadcrumbItem}</h4> */}
          <div className="page-title-right">
            <div className="breadcrumb m-0 tc-flex-gap-10px">
              <Link className="tc-text-primary" to={link}>
                {title}
              </Link>
              <div>/</div>
              <h1 className="tc-h1-breadcrumb-section-title">{breadcrumbItem}</h1>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
}
